import { render } from "./OrderScan.vue?vue&type=template&id=3b1d9c1c&scoped=true"
import script from "./OrderScan.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderScan.vue?vue&type=script&setup=true&lang=js"

import "./OrderScan.vue?vue&type=style&index=0&id=3b1d9c1c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1d9c1c"],['__file',"src/pages/components/templates/orderScan/OrderScan.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b1d9c1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b1d9c1c', __exports__)) {
    console.log('reload')
    api.reload('3b1d9c1c', __exports__)
  }
  
  module.hot.accept("./OrderScan.vue?vue&type=template&id=3b1d9c1c&scoped=true", () => {
    console.log('re-render')
    api.rerender('3b1d9c1c', render)
  })

}


export default __exports__